// removed by extract-text-webpack-plugin
module.exports = {"outerContainer":"outerContainer__1LI7L","coloredContainer":"coloredContainer__3k8ln","mobileScreen":"mobileScreen__1XhSs","imgContainer":"imgContainer__kmOSO","content":"content__1Vz-G","contentHeader":"contentHeader__30Tmw","checkEligibleBtn":"checkEligibleBtn__3-ZBJ","floatingCard":"floatingCard__T-yq4","campaignEnterMobileInputContainer":"campaignEnterMobileInputContainer__1zF7z","mobileNoPrefix":"mobileNoPrefix__1eElG","campaignEnterInputBoxMobile":"campaignEnterInputBoxMobile__2Perp","eligibilityCheckContainer":"eligibilityCheckContainer__2fNZh","otpText":"otpText__1-yPY"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/shopWithCardless/style.css
// module id = VwIJ
// module chunks = 446